<div class="lcl-dashboard-wrapper" *ngIf="!(isLoading$ | async)">
  <ng-container *ngIf="!(allQuotes$ | async)?.length && !(shipments$ | async)?.length">
    <h3>{{ "MENU.EEZY_FREIGHT" | translate }}</h3>
    <lcl-empty-list-placeholder></lcl-empty-list-placeholder>
  </ng-container>

  <ng-container *ngIf="(allQuotes$ | async)?.length && !(shipments$ | async)?.length">
    <div class="d-flex align-items-center">
      <h3>{{ "LABELS.MY_FREIGHT_QUOTES" | translate }}</h3>

      <button type="button" class="btn btn-link btn-sm ml-2" [routerLink]="['/lcl-shipping']" [queryParams]="{ showQuotes: true }">
        {{ "BUTTON.SHOW_MORE" | translate }}
      </button>
    </div>
    <ng-container *ngFor="let quote of (allQuotes$ | async).slice(0, 3); trackBy: trackByFn">
      <ng-container
        *ngIf="!quote.isManualQuote"
        [ngTemplateOutlet]="regularQuote"
        [ngTemplateOutletContext]="{ quote: quote }"
      ></ng-container>

      <ng-container
        *ngIf="quote.isManualQuote"
        [ngTemplateOutlet]="manualQuote"
        [ngTemplateOutletContext]="{ quote: quote }"
      ></ng-container>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="(shipments$ | async)?.length">
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <h3>{{ "LABELS.MY_ACTIVE_SHIPMENTS" | translate }}</h3>

        <button type="button" class="btn btn-link btn-sm ml-2" [routerLink]="['/lcl-shipping']" [queryParams]="{ showShipments: true }">
          {{ "BUTTON.SHOW_MORE" | translate }}
        </button>
      </div>

      <button type="button" class="btn btn-link btn-sm" [routerLink]="['/lcl-shipping']" [queryParams]="{ showQuotes: true }">
        {{ "LABELS.MY_LATEST_QUOTES" | translate : { count: (quotes$ | async)?.length } }}
      </button>
    </div>

    <ng-container *ngFor="let shipment of shipments$ | async; trackBy: trackByFn">
      <app-lcl-dashboard-shipment-card
        *ngIf="!isLaptop"
        [shipment]="shipment"
        [routerLink]="['/lcl-shipping', shipment.id, 'shipment']"
      ></app-lcl-dashboard-shipment-card>
      <mobile-lcl-card
        *ngIf="isLaptop"
        [isShipment]="true"
        [info]="shipment"
        [routerLink]="['/lcl-shipping', shipment.id, 'shipment']"
      ></mobile-lcl-card>
    </ng-container>
  </ng-container>
</div>

<ng-template #regularQuote let-quote="quote">
  <mobile-lcl-card
    *ngIf="isLaptop"
    [isShipment]="false"
    [info]="quote"
    [routerLink]="['/lcl-shipping', quote.id, 'booking']"
  ></mobile-lcl-card>
  <app-lcl-dashboard-quote-card
    [quote]="quote"
    [routerLink]="['/lcl-shipping', quote.id, 'booking']"
    *ngIf="!isLaptop"
  ></app-lcl-dashboard-quote-card>
</ng-template>

<ng-template #manualQuote let-quote="quote">
  <mobile-lcl-manual-quote-card *ngIf="isLaptop" [quote]="quote"></mobile-lcl-manual-quote-card>
  <app-lcl-dashboard-manual-quote-card *ngIf="!isLaptop" [quote]="quote"></app-lcl-dashboard-manual-quote-card>
</ng-template>
